module.exports = __webpack_public_path__ + "img/delete.743bfc56.svg";